import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import Cookies from "universal-cookie";
import FullPageLoader from "../../loaders/fullPageLoader";
import { useUser } from "../../Profile_And_account/Profile/UserProvider";
import RouteFallback from "../../loaders/RouteFallback";

const INDIVIDUAL = ["individual"];

export default function RequireUserType({
    allowed = INDIVIDUAL,
    allowGuests = true,
    redirectTo = "/",
}) {
    const { userType, accountLoading, isLoggedIn } = useUser();
    const location = useLocation();

    const cookies = new Cookies();
    const cookieUserId = cookies.get("finuserid");

    const authed = isLoggedIn ?? !!cookieUserId;

    if (!authed) {
        return allowGuests ? <Outlet /> : <Navigate to={redirectTo} replace />;
    }

    if (accountLoading || !userType) {
        return <RouteFallback />;
    }

    if (!allowed.includes(userType)) {
        return (
            <Navigate to={redirectTo} replace state={{ from: location.pathname }} />
        );
    }

    return <Outlet />;
}